import guideComponent from './guide.component';
import guideStepComponent from './guideStep.component';
import './guide.less';

angular.module('rym.guide', []).component('rymGuide', guideComponent).component('rymGuideStep', guideStepComponent);
